const CardStatus = {
  ACTIVE: 'active',
  ACTIVATION_IN_PROGRESS: 'activation-in-progress',
  INCOMPLETE: 'incomplete',
  ISSUED: 'issued',
  APPROVED: 'approved',
  UNDER_REVIEW: 'under-review',
  REJECTED: 'rejected',
  SET_PIN: 'set-pin',
  LOCKED: 'locked',
  MANUAL_ACTIVATION: 'manual-activation',
};

export default CardStatus;
